const QUIZ_STORAGE_PREFIX = "quiz_answers_";
const QUIZ_STORAGE_EXPIRY_DAYS = 30;

export const saveQuizAnswersToStorage = (identifier, answerId, answers) => {
  if (!identifier) {
    return;
  }

  if (!answers || Object.keys(answers).length === 0) {
    return;
  }

  try {
    const storageKey = `${QUIZ_STORAGE_PREFIX}${identifier}`;
    const data = {
      identifier,
      answerId,
      answers,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(storageKey, JSON.stringify(data));
  } catch (error) {
    console.error("Error saving quiz answers to storage:", error);
  }
};

export const getQuizAnswersFromStorage = (identifier) => {
  if (!identifier) {
    return null;
  }

  try {
    const storageKey = `${QUIZ_STORAGE_PREFIX}${identifier}`;
    const stored = localStorage.getItem(storageKey);

    if (!stored) {
      return null;
    }

    const data = JSON.parse(stored);

    const storedDate = new Date(data.timestamp);
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() - QUIZ_STORAGE_EXPIRY_DAYS);

    if (storedDate < expiryDate) {
      localStorage.removeItem(storageKey);
      return null;
    }

    return data.answers || null;
  } catch (error) {
    return null;
  }
};

export const clearQuizAnswersFromStorage = (identifier) => {
  if (!identifier) {
    return;
  }

  try {
    const storageKey = `${QUIZ_STORAGE_PREFIX}${identifier}`;
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.error("Error clearing quiz answers from storage:", error);
  }
};

export const mergeQuizAnswers = (serverAnswers, storageAnswers) => {
  if (!storageAnswers || Object.keys(storageAnswers).length === 0) {
    return serverAnswers || {};
  }

  if (!serverAnswers || Object.keys(serverAnswers).length === 0) {
    return storageAnswers;
  }

  const merged = { ...storageAnswers };

  Object.keys(serverAnswers).forEach((key) => {
    const storageValue = storageAnswers[key];
    const serverValue = serverAnswers[key];

    if (
      storageValue === null ||
      storageValue === undefined ||
      storageValue === ""
    ) {
      if (
        serverValue !== null &&
        serverValue !== undefined &&
        serverValue !== ""
      ) {
        merged[key] = serverValue;
      } else {
        merged[key] = storageValue;
      }
    } else {
      merged[key] = storageValue;
    }
  });

  return merged;
};
